<template>
<div>
    <div class="banner">
    </div>
    <ul class="news">
        <li v-for='item in news.list'>
            <a :href="getLink(item)"  target="_blank">
                {{item.title_sim}}
                <span class='date'>{{item.created_at}}</span>
            </a>
        </li>
    </ul>
</div>
</template>
<script type="text/javascript">
import Common from '@/common/Common'
import Request from '@/common/Request'
import Storage from '@/common/Storage'

export default {
    data : function(){
        return {
            'news' : {
                'list' : false
            }
        }
    },
    methods : {
        'getNews': function () {
            var url = Request.createApi('/app/news/list?where[position]=list&page=1')
            Request.get(url, res => {
                this.news.list = res.list
            })
        },
        'toNews' : function(news){
            Storage.set('news', news)
            Common.toUrl('/news/item?id='+news.id)
        },
        'getLink' : function (news) {
            return '/#/news/item?id='+news.id
        }
    },
    created : function(){
        this.getNews()
    }
}
</script>
<style scoped>
    *{
        padding: 0;
        margin: 0;
    }
    .banner{
        width: 711px;
        height: 215px;
        background: url("/static/image/index/banner.jpg");
        background-size: cover;
        margin: 0 auto;
    }
    ul.news{
        margin: 0 auto;
        width: 711px;
        list-style: none;
        padding-left: 0px;
        font-size: 12px;
        margin-top: 1px;
    }
    ul.news li{
        cursor: pointer;
        padding: 4px 5px;
        position: relative;
        padding-left: 15px;
        border-bottom: #bcbcbc 1px dashed;
    }
    ul.news li:before{
        content: ' ';
        display: inline-block;
        width: 6px;
        height: 6px;
        position: absolute;
        left: 5px;
        top: 13px;
        border-radius: 50%;
        background-color: #ff9434;
    }
    ul.news li .type{
        color: #F33;
    }
    ul.news li .date{
        float: right;
    }
</style>


// WEBPACK FOOTER //
// src/components/news/Inner.vue